import { configureStore } from '@reduxjs/toolkit'
import authenticationReducer from "./slices/authentication.slice";
const reducer = {
  authentication: authenticationReducer
}
const store = configureStore({
  reducer: reducer,
  devTools: true,
})
export default store;